<div
  class="flex-column hierarchy-container"
  [ngClass]="{
    'people-preview-large': isLargeMode
  }"
>
  <!-- firstAboveItem -->
  <hierarchy-item
    *ngIf="viewModel.mostSuperiorItem"
    [isPopUp]="isPopUp"
    [item]="viewModel.mostSuperiorItem"
    [isSelected]="selectedElement === 'top-hierarchy-item'"
    [smallWidth]="smallWidthPreview"
    (selectedItem)="onSelectedItem(viewModel.mostSuperiorItem, viewModel.superiorItems ? viewModel.superiorItems.length - 1 : 1)"
    #hierarchyItem
    id="top-hierarchy-item"
    [ngClass]="{ focused: 'top-hierarchy-item' === focusedElementId }"
  ></hierarchy-item>
  <!-- aboveItems-more than 2 -->
  <div *ngIf="viewModel.superiorItems">
    <hierarchy-item
      *ngIf="viewModel.superiorItems.length === 1; else superiorItems"
      #hierarchyItem
      id="hierarchy-item"
      [ngClass]="{ focused: 'hierarchy-item' === focusedElementId }"
      [isPopUp]="isPopUp"
      [item]="viewModel.superiorItems[0]"
      [isSelected]="selectedElement === 'hierarchy-item'"
      [smallWidth]="smallWidthPreview"
      (selectedItem)="onSelectedItem(viewModel.superiorItems[0], 1)"
    ></hierarchy-item>
    <ng-template #superiorItems>
      <div
        data-cy="people-preview-more-hidden-items"
        [ngClass]="{
          'hierarchy-circle-count': !openSuperiorItems,
          'hierarchy-avatar': true,
          'hierarchy-count-above': true,
          'display-none': openSuperiorItems,
          focused: 'count' === focusedElementId
        }"
        (click)="emitOpenSuperiorItems()"
        #count
        id="count"
      >
        <span>{{ viewModel.superiorItems.length }}</span>
      </div>
    </ng-template>
    <div [ngClass]="{ 'hierarchy-seperate-line-column': true, 'display-none': openSuperiorItems }"></div>
    <div class="flex-column display-none" [ngClass]="{ 'open-above-items': openSuperiorItems }">
      <hierarchy-item
        [isPopUp]="isPopUp"
        *ngFor="let item of viewModel.superiorItems; let i = index"
        (selectedItem)="onSelectedItem(item, viewModel.superiorItems.length - i + 1)"
        [item]="item"
        #hierarchyHiddenItem
        [isSelected]="selectedElement === 'hierarchy-item' + i"
        [smallWidth]="smallWidthPreview"
        [id]="'hierarchy-item' + i"
        [ngClass]="{ focused: 'hierarchy-item' + i === focusedElementId }"
      ></hierarchy-item>
    </div>
  </div>
  <!-- secondAboveItem -->
  <hierarchy-item
    *ngIf="viewModel.directSuperiorItem"
    [isPopUp]="isPopUp"
    [item]="viewModel.directSuperiorItem"
    [isSelected]="selectedElement === 'hierarchy-above'"
    [smallWidth]="smallWidthPreview"
    (selectedItem)="onSelectedItem(viewModel.directSuperiorItem, 0)"
    #hierarchyAboveItem
    id="hierarchy-above"
    [ngClass]="{ focused: 'hierarchy-above' === focusedElementId }"
  ></hierarchy-item>
  <!-- currentItem -->
  <hierarchy-item
    *ngIf="viewModel.currentItem"
    [isPopUp]="isPopUp"
    [item]="viewModel.currentItem"
    [smallWidth]="smallWidthPreview"
    [hasChild]="viewModel.firstSubordinateItem || viewModel.subordinateItems"
    [isCurrent]="true"
  ></hierarchy-item>
  <!-- only one belowItem -->
  <hierarchy-item
    *ngIf="viewModel.firstSubordinateItem"
    [isPopUp]="isPopUp"
    [item]="viewModel.firstSubordinateItem"
    [hasChild]="false"
    [isSelected]="selectedElement === 'hierarchy-below'"
    [smallWidth]="smallWidthPreview"
    (selectedItem)="onSelectedItem(viewModel.firstSubordinateItem, 0)"
    #hierarchyBelowItem
    id="hierarchy-below"
    [ngClass]="{ focused: 'hierarchy-below' === focusedElementId }"
  ></hierarchy-item>
  <!--  two and more belowItems -->
  <div *ngIf="viewModel.subordinateItems" class="flex-row hierarchy-wrapper-subordinate-items">
    <div *ngFor="let i of indexArray" class="flex-row">
      <avatar
        (click)="onSelectedItem(viewModel.subordinateItems[i], i, 'subordinate')"
        #avatarBelowItem
        [id]="'avatar-below' + i"
        [ngClass]="{ focused: 'avatar-below' + i === focusedElementId }"
        class="hierarchy-avatar avatar-below"
        [url]="viewModel.subordinateItems[i]?.icon"
        [tooltipDisabled]="!(viewModel?.subordinateItems.length === 2 || viewModel?.subordinateItems.length === 3)"
        [pTooltip]="viewModel.subordinateItems[i]?.title"
        [size]="'none'"
        tooltipPosition="bottom"
        tooltipStyleClass="u-tooltip"
        [ngClass]="{
          'hierarchy-avatar-in-group': i != 0 && viewModel?.subordinateItems.length > 2,
          'hierarchy-avatar-with-hover': [2, 3].includes(viewModel?.subordinateItems.length)
        }"
        [fallback]="viewModel.subordinateItems[i]?.fallbackIcon"
      >
      </avatar>
      <div *ngIf="viewModel?.subordinateItems.length === 2 && i == 0" class="hierarchy-seperate-line hierarchy-seperate-line-row"></div>
    </div>
    <div *ngIf="viewModel?.subordinateItems.length > 3" class="flex-row">
      <div class="hierarchy-circle-count hierarchy-avatar hierarchy-avatar-in-group">
        <span>{{ viewModel.subordinateItems.length }}</span>
      </div>
      <div class="open-icon-container" [ngClass]="{ focused: 'open-icon' === focusedElementId }">
        <div class="hierarchy-icon-open" [id]="'open-icon'" (click)="openPopupSubordinateItems($event)" #openHierarchyIcon></div>
      </div>
    </div>
  </div>
</div>
